import { Container, Stack } from '@mantine/core';
import PackageList from '../components/package/PackageList';
import PageTitle from '../components/common/PageTitle';

const Packages = () => {
  return (
    <Container size="xl" pb="xl">
      <Stack gap="lg">
        <PageTitle
          title="My Packages"
          description="View and manage your packages received at our warehouse. Select packages to access shipping, consolidation, return to sender, or disposal options."
          withBorder
        />

        <PackageList />
      </Stack>
    </Container>
  );
};

export default Packages;
